import * as decision from '../../core/decision';
import { isAttributeValid } from '../../utils/attributes_validator';
import * as eventTagUtils from '../../utils/event_tag_utils';
import fns from '../../utils/fns';
import { getAttributeId, getEventId, getLayerId, } from '../../project_config/project_config';
import { DECISION_SOURCES } from '../../common_exports';
export const areEventContextsEqual = (eventA, eventB) => {
    const contextA = eventA.context;
    const contextB = eventB.context;
    const regionA = contextA.region || 'US';
    const regionB = contextB.region || 'US';
    return (regionA === regionB &&
        contextA.accountId === contextB.accountId &&
        contextA.projectId === contextB.projectId &&
        contextA.clientName === contextB.clientName &&
        contextA.clientVersion === contextB.clientVersion &&
        contextA.revision === contextB.revision &&
        contextA.anonymizeIP === contextB.anonymizeIP &&
        contextA.botFiltering === contextB.botFiltering);
};
const buildBaseEvent = ({ configObj, userId, userAttributes, clientEngine, clientVersion, type, }) => {
    return {
        type,
        timestamp: fns.currentTimestamp(),
        uuid: fns.uuid(),
        context: {
            region: configObj.region,
            accountId: configObj.accountId,
            projectId: configObj.projectId,
            revision: configObj.revision,
            clientName: clientEngine,
            clientVersion: clientVersion,
            anonymizeIP: configObj.anonymizeIP || false,
            botFiltering: configObj.botFiltering,
        },
        user: {
            id: userId,
            attributes: buildVisitorAttributes(configObj, userAttributes),
        },
    };
};
/**
 * Creates an ImpressionEvent object from decision data
 * @param  {ImpressionConfig}  config
 * @return {ImpressionEvent}   an ImpressionEvent object
 */
export const buildImpressionEvent = function ({ configObj, decisionObj, userId, flagKey, enabled, userAttributes, clientEngine, clientVersion, }) {
    const ruleType = decisionObj.decisionSource;
    const experimentKey = decision.getExperimentKey(decisionObj);
    const experimentId = decision.getExperimentId(decisionObj);
    const variationKey = decision.getVariationKey(decisionObj);
    const variationId = decision.getVariationId(decisionObj);
    const cmabUuid = decisionObj.cmabUuid;
    const layerId = experimentId !== null ? (ruleType === DECISION_SOURCES.HOLDOUT ? '' : getLayerId(configObj, experimentId)) : null;
    return Object.assign(Object.assign({}, buildBaseEvent({
        configObj,
        userId,
        userAttributes,
        clientEngine,
        clientVersion,
        type: 'impression',
    })), { layer: {
            id: layerId,
        }, experiment: {
            id: experimentId,
            key: experimentKey,
        }, variation: {
            id: variationId,
            key: variationKey,
        }, ruleKey: experimentKey, flagKey: flagKey, ruleType: ruleType, enabled: enabled, cmabUuid });
};
/**
 * Creates a ConversionEvent object from track
 * @param  {ConversionConfig} config
 * @return {ConversionEvent}  a ConversionEvent object
 */
export const buildConversionEvent = function ({ configObj, userId, userAttributes, clientEngine, clientVersion, eventKey, eventTags, }, logger) {
    const eventId = getEventId(configObj, eventKey);
    const revenue = eventTags ? eventTagUtils.getRevenueValue(eventTags, logger) : null;
    const eventValue = eventTags ? eventTagUtils.getEventValue(eventTags, logger) : null;
    return Object.assign(Object.assign({}, buildBaseEvent({
        configObj,
        userId,
        userAttributes,
        clientEngine,
        clientVersion,
        type: 'conversion',
    })), { event: {
            id: eventId,
            key: eventKey,
        }, revenue: revenue, value: eventValue, tags: eventTags });
};
const buildVisitorAttributes = (configObj, attributes, logger) => {
    if (!attributes) {
        return [];
    }
    // Omit attribute values that are not supported by the log endpoint.
    const builtAttributes = [];
    Object.keys(attributes).forEach(function (attributeKey) {
        const attributeValue = attributes[attributeKey];
        if (typeof attributeValue === 'object' || typeof attributeValue === 'undefined') {
            return;
        }
        if (isAttributeValid(attributeKey, attributeValue)) {
            const attributeId = getAttributeId(configObj, attributeKey, logger);
            if (attributeId) {
                builtAttributes.push({
                    entityId: attributeId,
                    key: attributeKey,
                    value: attributeValue,
                });
            }
        }
    });
    return builtAttributes;
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=user_event.js.map